import React from 'react';
import { OptionSelector as UIOptionSelector } from '@shopee/chatbot-ui';
import { ButtonAction, ButtonType, getButtonAction, getButtonType } from '@/utils/getButtonData';
import { OptionSelectorProps as UIOptionSelectorProps } from '@shopee/chatbot-ui/lib/components/OptionSelector';
import { handleClickHistoryButton } from '@/utils/tools';
import { TRACKING_SECTION, TRACKING_TARGET, TRACKING_TYPE } from '@/utils/tracking/constants';
import { ChatbotUIBasicProps } from '@/types/common';
import { INPUT_TYPE, TRACKING_MSG_TYPE } from '@/utils/constants';
import { isBank } from '@/config/core';

import RcmdUIOptimisationItem from './RcmdUIOptimisationItem';

export interface Option {
  content: string;
  option_id: string;
  action: {
    action_type: ButtonAction;
    task_bot_action: any;
  };
  sub_options?: Option[];
}
export type OptionSelectorProps = {
  taskbotInfo: any;
  content: string;
  options: Option[];
  isDisabled: boolean; // 隐藏按钮
  useUIOptimisationRecommender?: boolean;
} & ChatbotUIBasicProps;

const LEVEL = {
  First: 1,
  Second: 2,
};

const OptionSelector: React.FC<OptionSelectorProps> = (props) => {
  const { useUIOptimisationRecommender } = props;

  const nextParams = {
    session_id: props.sessionId,
    dialogue_id: props.dialogueId,
    thread_node_id: props.threadNodeId,
    thread_id: props.threadId,
    thread_id_v2: props.threadIdV2,
    round_id: props.roundId,
    is_bypass: false,
  };

  const options = props.isDisabled
    ? []
    : props.options?.map((option, index) => {
      const text = option.content;
      return {
        text,
        type: getButtonType(ButtonType.Text),
        disabled: props.isHistory ? true : false,
        onDisableClick: props.isHistory ? handleClickHistoryButton : undefined,
        action: option.action && {
          func: getButtonAction(option?.action?.action_type),
          ...option,
          info: props,
          nextParams: {
            ...nextParams,
            message_text: option.content,
            input_type: INPUT_TYPE.BUTTON,
            message_extra: { task_bot_action: Object.assign({ task_bot_info: props.taskbotInfo }, option?.action?.task_bot_action, { button_id: option.option_id }) },
          },
        },
        trackingData: {
          trackingsection: TRACKING_SECTION[TRACKING_TYPE.CLARIFICATION_LIST],
          trackingtarget: TRACKING_TARGET[TRACKING_TYPE.CLARIFICATION_LIST],
          trackingdataBasic: {
            chat_session_id: props.isHistory ? props.historySessionId : props.sessionId || '',
            chat_dialogue_id: props.isHistory ? props.historyDialogueId : props.dialogueId,
            taskbot_id: props.taskbotInfo?.task_bot_id,
            taskflow_id: props.taskbotInfo?.flow_id,
            node_point_id: props.nodePointId,
            kb_bot_id: props.kbBotId,
            if_history: props.isHistory ? TRACKING_MSG_TYPE.HISTORY : TRACKING_MSG_TYPE.REAL_TIME,
            button_text: option.content,
            location: index,
            button_type: (option.action?.action_type || ButtonAction.JumpNode)?.toString?.(),
            button_id: option.option_id,
            tf_node_id: props.tfNodeId,
            tf_case_id: props.tfCaseId,
            clarification_level: LEVEL.First,
          },
        },
        subOptions: option.sub_options?.map((subOption: any, subOptionIndex) => ({
          buttonId: subOption.sub_option_id,
          type: getButtonType(ButtonType.Text),
          text: subOption.content,
          disabled: props.isHistory ? true : false,
          onDisableClick: props.isHistory ? handleClickHistoryButton : undefined,
          action: subOption.action && {
            func: getButtonAction(subOption?.action?.action_type),
            ...subOption,
            info: props,
            nextParams: {
              ...nextParams,
              message_text: subOption.content,
              input_type: INPUT_TYPE.BUTTON,
              message_extra: {
                task_bot_action: Object.assign(
                  { task_bot_info: props.taskbotInfo },
                  subOption?.action?.task_bot_action,
                  { button_id: subOption.sub_option_id },
                ),
              },
            },
          },
          trackingData: {
            trackingsection: TRACKING_SECTION[TRACKING_TYPE.CLARIFICATION_LIST],
            trackingtarget: TRACKING_TARGET[TRACKING_TYPE.CLARIFICATION_LIST],
            trackingdataBasic: {
              chat_session_id: props.isHistory ? props.historySessionId : props.sessionId || '',
              chat_dialogue_id: props.isHistory ? props.historyDialogueId : props.dialogueId,
              taskbot_id: props.taskbotInfo?.task_bot_id,
              taskflow_id: props.taskbotInfo?.flow_id,
              node_point_id: props.nodePointId,
              kb_bot_id: props.kbBotId,
              if_history: props.isHistory ? TRACKING_MSG_TYPE.HISTORY : TRACKING_MSG_TYPE.REAL_TIME,
              button_text: subOption.content,
              location: subOptionIndex,
              button_type: subOption.action?.action_type?.toString?.(),
              button_id: subOption.sub_option_id,
              tf_node_id: props.tfNodeId,
              tf_case_id: props.tfCaseId,
              clarification_level: LEVEL.Second,
            },
          },
        })),
        ...RcmdUIOptimisationItem(text, useUIOptimisationRecommender),
      };
    });

  return (
    <UIOptionSelector
      className={`${useUIOptimisationRecommender ? 'rcmd-ui-optimisation-container' : ''} ${
        isBank() ? 'chatbot-bank-list' : ''
      }`}
      content={props.content}
      options={options as unknown as UIOptionSelectorProps['options']}
    />
  );
};

export default OptionSelector;
